import axios from 'axios';
import { ElLoading, ElMessageBox } from 'element-plus';



const UPLOAD_HOST = 'https://xf-aplus.oss-cn-hongkong.aliyuncs.com/';


const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '192.168.4.93';

const API_CONFIG = {
  host: 'https://apialphasight.pearlexplorer.io/api/app/' // 线上生产环境地址
  // host: isDev  ? 'http://192.168.4.93:1910/api/app/' : 'https://apialphasight.pearlexplorer.io/api/app/', // 线上生产环境地址
};


const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};




/**
 * 统一请求处理函数
 * @param {string} method - 请求方法 (get/post)
 * @param {string} url - 接口路径
 * @param {Object} data - 请求数据
 * @param {Object} customHeaders - 自定义头
 * @returns {Promise}
 */
async function request(method, url, data = null, customHeaders = {}) {
  const token = localStorage.getItem('tokens');
  const config = {
    method,
    url: API_CONFIG.host + url,
    timeout: 10000,
    responseType: 'json',
    headers: {
      ...DEFAULT_HEADERS,
      ...customHeaders,
      tokens: token || '',
    },
  };

  // 根据 method 处理参数
  if (method.toLowerCase() === 'get') {
    config.params = data;
  } else {
    config.data = data;
  }

  try {
    const response = await axios(config);
    return handleResponse(response, url);
  } catch (error) {
    showErrorMessage('请求错误，请稍后重试');
    return false;
  }
}

/**
 * 响应数据处理与业务拦截
 */
function handleResponse(response, url) {

  const { data, headers } = response;


  if (headers && headers.tokens) {
    localStorage.setItem('tokens', headers.tokens);
  }



  if (data.code == 200) {
    return data;
  } else if (data.code == 401) {
    window.location.href = '/login';
  } else {
    showErrorMessage(data.msg || '请求异常');
  }

  return false;
}



/**
 * 统一错误提示
 */
function showErrorMessage(message) {
  ElMessageBox.alert(message, '提示', {
    type: 'error',
    showClose: false,
    confirmButtonText: '确定',
  }).catch(() => {
    /* 忽略取消关闭 */
  });
}




/**
 * 阿里云 OSS 文件上传
 * @param {File} file - 文件对象
 * @param {Object} config - 上传凭证 (accessid, policy, signature, directory)
 * @returns {Promise}
 */
async function uploadFile(file, config) {
  if (!file || !file.name) {
    showErrorMessage('无效的文件对象');
    return;
  }

  const fileName = generateUniqueFileName(file.name, config.directory || 'adm/');

  const formData = new FormData();
  formData.append('key', fileName);
  formData.append('OSSAccessKeyId', config.accessid);
  formData.append('policy', config.policy);
  formData.append('Signature', config.signature);
  formData.append('success_action_status', '200');
  formData.append('file', file);

  try {
    await axios.post(UPLOAD_HOST, formData, {
      timeout: 120000,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return { code: 200, url: UPLOAD_HOST + fileName };
  } catch (error) {
    console.error('Upload Error:', error);
    showErrorMessage('文件上传失败');
    return false;
  }
}


/**
 * 生成唯一文件名
 */
function generateUniqueFileName(originalName, directory) {
  const ext = originalName.substring(originalName.lastIndexOf('.'));
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1000);
  return `${directory}${timestamp}_${random}${ext}`;
}


export default {
  get(url, options, headers) {
    return request('get', url, options, headers);
  },
  post(url, options, headers) {
    return request('post', url, options, headers);
  },
  upload(file, config) {
    return uploadFile(file, config);
  },
};